import React, { useMemo } from 'react';
import Spinner from './Spinner';

// Function to generate a random alphanumeric string of a given length
const generateRandomId = (length: number) => {
  let result = '';
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

// Function to generate a random IPv4 address
const generateRandomIp = () => {
  return Array.from({ length: 4 }, () => Math.floor(Math.random() * 256)).join('.');
};

// Function to generate a single Weft string
const generateWeftString = () => {
  const id = generateRandomId(11);
  const ip = generateRandomIp();
  return `weft://${id}@${ip}`;
};

interface WeftSpinnerProps {
  count?: number;
  interval?: number;
  className?: string;
}

const WeftSpinner: React.FC<WeftSpinnerProps> = ({ count = 5, interval, className = "text-warning" }) => {
  const weftStrings = useMemo(() => {
    return Array.from({ length: count }, generateWeftString);
  }, [count]);

  return (
    <Spinner items={weftStrings} interval={interval} className={className} />
  );
};

export default WeftSpinner;
